import MyAccount from "../components/User/MyAccount";

const MyAccountPage = (): JSX.Element => {
  return <MyAccount />;
};

export default MyAccountPage;
